
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useRecruiterRole() {
  const [isRecruiter, setIsRecruiter] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [hasNetworkError, setHasNetworkError] = useState<boolean>(false);

  const checkRecruiterStatus = async (): Promise<boolean> => {
    setIsLoading(true);
    setHasNetworkError(false);
    try {
      const { data, error } = await supabase.rpc("is_recruiter");

      if (error) {
        setHasNetworkError(true);
        return false;
      }

      if (typeof data !== "boolean") {
        return false;
      }
      setIsRecruiter(data);
      return data;
    } catch (err) {
      setHasNetworkError(true);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const clearCacheAndRecheck = async (): Promise<boolean> => {
    // Clear any local cache if needed
    return await checkRecruiterStatus();
  };

  useEffect(() => {
    checkRecruiterStatus();
  }, []);

  return {
    isRecruiter,
    isLoading,
    hasNetworkError,
    clearCacheAndRecheck,
  };
}
